<template>
  <div class="labelGroup">

    <div class="labelGroup_buttonArea">
      <el-button type="success" icon="el-icon-plus" @click="searchLabel = true">添加标签组</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addLabel = true">添加标签</el-button>
    </div>

    <div class="labelGroup_contentArea">
      <el-table
        v-loading="loading"
        border
        :data="list"
        style="width: 100%"
      >
        <el-table-column
          fixed
          prop="tagGroupName"
          label="组名"
          width="320"
          align="center"
        />
        <el-table-column
          prop="platformId"
          label="平台"
          align="center"
        >
          <template slot-scope="scope">
            {{ platforms.filter(item=>item.id === scope.row.platformId).length? platforms.filter(item=>item.id === scope.row.platformId)[0].name : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="realName"
          label="创建人"
          align="center"
        />
        <el-table-column
          prop="createdAtText"
          label="创建时间"
          align="center"
        />
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="(labelDetails = true),(activeItem = scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <LabelDetails v-if="labelDetails" :active-item="activeItem" :platforms="platforms" @close="(labelDetails = false),(activeItem = null)" />
    <SearchLabel v-if="searchLabel" :base-tag="baseTag" :platforms="platforms" @close="close" />
    <AddLabel v-if="addLabel" @close="addLabel = false" />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import SearchLabel from './components/SearchLabel.vue'
import AddLabel from './components/addLabel.vue'
import { getList, getPlatform/* , labelDetails  */ } from '@/api/labelGroup.js'
import LabelDetails from './components/LabelDetails'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    SearchLabel,
    LabelDetails,
    AddLabel
  },
  mixins: [convertToHump],
  data() {
    return {
      pageIfon: {
        pageSize: 10,
        page: 1,
        groupName: undefined,
        adminId: undefined
      },
      list: [],
      loading: false,
      total: null,
      baseTag: {},
      searchLabel: false,
      addLabel: false,
      labelDetails: false,
      activeItem: null,
      platforms: [] // 平台组
    }
  },
  created() {
    this.getLabelGroupList()
    this.getPlatform()
  },
  methods: {
    fetchPageSize(num) {
      this.pageIfon.pageSize = num
      this.getLabelGroupList()
    },
    fetchCurrentPage(num) {
      this.pageIfon.page = num
      this.getLabelGroupList()
    },
    async getLabelGroupList() {
      this.loading = true
      const data = await getList(this.pageIfon)
      this.loading = false
      this.list = this.convertToHump(data.data.list)
      this.total = data.data.total
      this.baseTag = this.convertToHump(data.data.baseTag)
    },
    close(bool) {
      this.searchLabel = false
      if (bool) {
        this.getLabelGroupList()
      }
    },
    async getPlatform() {
      const data = await getPlatform()
      this.platforms = data.data.list
    }
  }
}
</script>

<style scoped lang="less">
.labelGroup{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
   .labelGroup_buttonArea{
     margin: 10px;
     text-align: right;
   }
   .labelGroup_contentArea{

   }
}
</style>
